import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { useFormikContext } from 'formik';
import { FilterFormValues } from '../types';
import EntitySearchField from './EntitySearchField';
import EntityTypeField from './EntityTypeField';
import ProductFamilyField from './ProductFamilyField';

const useStyles = makeStyles(theme => {
  return {
    container: {
      [theme.breakpoints.up('lg')]: {
        position: 'sticky'
      },
      zIndex: 100,
      top: 0,
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(3),
      boxShadow: theme.shadows[2],
      background: 'white'
    },
    select: {
      width: '100%'
    },
    buttonContainer: {
      height: '100%',
      alignContent: 'flex-end'
    },
    label: {
      fontWeight: 600
    },
    iconButton: {
      width: 36,
      height: 36,
      minWidth: 'unset',
      padding: 'unset'
    },
    iconButtonSelected: {
      backgroundColor: `${theme.palette.secondary.main} !important`
    },
    icon: {
      height: 18,
      width: 18
    },
    iconSelected: {
      color: 'white'
    },
    productFamilyContainer: {
      [theme.breakpoints.up('md')]: {
        minWidth: '240px',
        maxWidth: '240px'
      }
    },
    entityTypeContainer: {
      [theme.breakpoints.up('md')]: {
        // minWidth: '230px',
        maxWidth: '230px'
      }
    },
    entitySearchContainer: {
      [theme.breakpoints.up('lg')]: {
        minWidth: '220px',
        maxWidth: '220px'
      }
    }
  };
});

const SharedFilters = (): React.ReactElement => {
  const classes = useStyles();
  const { handleChange, setFieldValue, values } = useFormikContext<FilterFormValues>();
  const { productFamilyCode, entityType } = values;

  const handleChangeEntityType = (e: React.ChangeEvent<HTMLInputElement>): void => {
    handleChange(e);
    setFieldValue('entityId', null);
  };

  return (
    <>
      <Grid xs={12} lg={3} item className={classes.productFamilyContainer}>
        <ProductFamilyField />
      </Grid>
      <Grid xs={12} md={6} lg={2} item className={classes.entityTypeContainer}>
        <EntityTypeField productFamilyCode={productFamilyCode} onChange={handleChangeEntityType} />
      </Grid>
      <Grid xs={12} md lg item className={classes.entitySearchContainer}>
        <EntitySearchField entityType={entityType} productFamilyCode={productFamilyCode} />
      </Grid>
    </>
  );
};

export default SharedFilters;
